import { Component, OnInit } from '@angular/core';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { V4Service } from 'src/app/services/v4.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-v2-variaciones',
  templateUrl: './v2-variaciones.component.html',
  styleUrls: ['./v2-variaciones.component.scss']
})
export class V2VariacionesComponent implements OnInit {
  variaciones: any[] = [];
  filtro = '';
  filtroTipo = '';
  filtroActivo = '';
  readonly tiposVariacionBase = ['Marco', 'Moldura', 'Color', 'Placa', 'Cuadro'];
  tiposProductoCatalogo: any[] = [];
  filtroTipoCatalogo = '';

  formVariacion = { tipo: '', nombre: '', activo: 1 };
  formVariacionEdit = { id: 0, tipo: '', nombre: '', activo: 1 };
  tipoForm = { nombre: '', descripcion: '', activo: 1 };
  tipoDestino: 'nuevo' | 'editar' = 'nuevo';
  configuraciones: any[] = [];
  configForm = { configuracion: '', descripcion: '', activo: 1 };
  configEditForm = { id: 0, configuracion: '', descripcion: '', activo: 1 };
  configImagen: File | null = null;
  filtroConfig = '';
  variacionConfigurando: any = null;
  configuracionFotosTarget: any = null;
  configuracionImagenes: any[] = [];
  configuracionImagenFiles: File[] = [];
  configuracionImagenForm = { titulo: '', orden: 0, activo: 1 };
  loadingConfigImagenes = false;

  loading = false;
  private readonly defaultImage = 'assets/img/auri_logo.png';
  private tipoModalRef: NgbModalRef | null = null;
  private editVariacionModalRef: NgbModalRef | null = null;
  private editConfiguracionModalRef: NgbModalRef | null = null;

  constructor(
    private v4: V4Service,
    private iziToast: Ng2IzitoastService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.getTiposProductoCatalogo();    
  }

  getTiposVariacion(tipoActual?: string): string[] {
    const tipos = this.tiposProductoCatalogo.length ? [] : [...this.tiposVariacionBase];
    const agregarTipo = (tipo?: string) => {
      const valor = (tipo || '').trim();
      if (valor && !tipos.some((item) => item.toLowerCase() === valor.toLowerCase())) {
        tipos.push(valor);
      }
    };

    this.tiposProductoCatalogo.forEach((tipo) => agregarTipo(tipo.nombre));
    this.variaciones.forEach((variacion) => agregarTipo(this.getVariacionTipo(variacion)));
    agregarTipo(tipoActual);

    return tipos;
  }

  get tiposProductoCatalogoFiltrados() {
    const term = this.filtroTipoCatalogo.toLowerCase();
    return this.tiposProductoCatalogo.filter((tipo) => {
      const nombre = (tipo.nombre || '').toLowerCase();
      const descripcion = (tipo.descripcion || '').toLowerCase();
      return !term || nombre.includes(term) || descripcion.includes(term);
    });
  }

  abrirAgregarTipo(modal: any, destino: 'nuevo' | 'editar' = 'nuevo'): void {
    this.tipoDestino = destino;
    this.tipoForm = { nombre: '', descripcion: '', activo: 1 };
    this.filtroTipoCatalogo = '';
    this.tipoModalRef = this.modalService.open(modal, { ariaLabelledBy: 'modal-agregar-tipo-variacion' });
  }

  agregarTipoVariacion(): void {
    const nombre = this.tipoForm.nombre.trim();
    if (!nombre) {
      this.toast('Nombre requerido', '#CA0B00');
      return;
    }
    if (this.getTiposVariacion().some((tipo) => tipo.toLowerCase() === nombre.toLowerCase())) {
      this.aplicarTipoNuevo(nombre);
      this.toast('Tipo ya existe');
      this.tipoModalRef?.close();
      this.tipoModalRef = null;
      return;
    }

    this.v4.crearTipoProducto({
      nombre,
      descripcion: this.tipoForm.descripcion,
      activo: this.tipoForm.activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          const tipoCreado = data.content || { nombre };
          this.tiposProductoCatalogo.push(tipoCreado);
          this.ordenarTiposCatalogo();
          this.aplicarTipoNuevo(tipoCreado.nombre || nombre);
          this.toast('Tipo creado');
          this.tipoModalRef?.close();
          this.tipoModalRef = null;
        } else {
          this.toast(this.getApiError(data) || 'No se pudo crear tipo', '#CA0B00');
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarTipoProducto(tipo: any): void {
    if (!tipo?.id || !confirm('Eliminar tipo?')) {
      return;
    }
    this.v4.eliminarTipoProducto(tipo.id).subscribe(
      (data: any) => {
        if (data.success) {
          this.tiposProductoCatalogo = this.tiposProductoCatalogo.filter((item) => Number(item.id) !== Number(tipo.id));
          if ((this.formVariacion.tipo || '').toLowerCase() === (tipo.nombre || '').toLowerCase()) {
            this.formVariacion.tipo = '';
          }
          if ((this.formVariacionEdit.tipo || '').toLowerCase() === (tipo.nombre || '').toLowerCase()) {
            this.formVariacionEdit.tipo = '';
          }
          this.toast('Tipo eliminado');
        } else {
          this.toast(this.getApiError(data) || 'No se pudo eliminar tipo', '#CA0B00');
        }
      },
      (error) => console.error(error)
    );
  }

  getVariacionTipo(variacion: any): string {
    return variacion?.tipo || variacion?.nombre || '';
  }

  getVariacionLabel(variacion: any): string {
    const tipo = this.getVariacionTipo(variacion);
    const nombre = variacion?.nombre || '';
    if (tipo && nombre && tipo.toLowerCase() !== nombre.toLowerCase()) {
      return `${nombre} (${tipo})`;
    }
    return nombre || tipo || '-';
  }

  getVariaciones(): void {
    this.loading = true;
    this.v4.getVariacionesBase().subscribe(
      (data: any) => {
        this.loading = false;
        if (data.success) {
          this.variaciones = data.content || [];
        }
      },
      (error) => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  agregarVariacion(): void {
    if (!this.formVariacion.tipo.trim()) {
      this.toast('Tipo requerido', '#CA0B00');
      return;
    }
    if (!this.formVariacion.nombre.trim()) {
      this.toast('Nombre requerido', '#CA0B00');
      return;
    }
    if (this.existeVariacion(this.formVariacion.tipo, this.formVariacion.nombre)) {
      this.toast('Ya existe esa variacion', '#CA0B00');
      return;
    }
    this.v4.crearVariacionBase({
      tipo: this.formVariacion.tipo,
      nombre: this.formVariacion.nombre,
      activo: this.formVariacion.activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Variacion creada');
          this.formVariacion = { tipo: '', nombre: '', activo: 1 };
          this.getVariaciones();
        } else {
          this.toast(this.getApiError(data) || 'No se pudo crear', '#CA0B00');
        }
      },
      (error) => console.error(error)
    );
  }

  seleccionarVariacion(modal: any, variacion: any): void {
    this.formVariacionEdit = {
      id: variacion.id,
      tipo: this.getVariacionTipo(variacion),
      nombre: variacion.nombre || '',
      activo: variacion.activo === 0 ? 0 : 1
    };
    this.variacionConfigurando = null;
    this.configuraciones = [];
    this.editVariacionModalRef = this.modalService.open(modal, { ariaLabelledBy: 'modal-editar-variacion' });
  }

  configurarVariacion(modal: any, variacion: any): void {
    this.formVariacionEdit = { id: 0, tipo: '', nombre: '', activo: 1 };
    this.variacionConfigurando = variacion;
    this.filtroConfig = '';
    this.configEditForm = { id: 0, configuracion: '', descripcion: '', activo: 1 };
    this.getConfiguraciones(variacion.id);
    this.modalService.open(modal, { ariaLabelledBy: 'modal-configuraciones', size: 'lg' });
  }

  actualizarVariacion(): void {
    if (!this.formVariacionEdit.id) { return; }
    if (!this.formVariacionEdit.tipo.trim()) {
      this.toast('Tipo requerido', '#CA0B00');
      return;
    }
    if (!this.formVariacionEdit.nombre.trim()) {
      this.toast('Nombre requerido', '#CA0B00');
      return;
    }
    if (this.existeVariacion(this.formVariacionEdit.tipo, this.formVariacionEdit.nombre, this.formVariacionEdit.id)) {
      this.toast('Ya existe esa variacion', '#CA0B00');
      return;
    }
    this.v4.actualizarVariacionBase(this.formVariacionEdit.id, {
      tipo: this.formVariacionEdit.tipo,
      nombre: this.formVariacionEdit.nombre,
      activo: this.formVariacionEdit.activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Variacion actualizada');
          this.formVariacionEdit = { id: 0, tipo: '', nombre: '', activo: 1 };
          this.editVariacionModalRef?.close();
          this.editVariacionModalRef = null;
          this.getVariaciones();
          this.variacionConfigurando = null;
          this.configuraciones = [];
        } else {
          this.toast(this.getApiError(data) || 'No se pudo actualizar', '#CA0B00');
        }
      },
      (error) => console.error(error)
    );
  }

  toggleVariacion(variacion: any): void {
    const activo = variacion.activo === 0 ? 1 : 0;
    this.v4.actualizarVariacionBase(variacion.id, {
      tipo: this.getVariacionTipo(variacion),
      nombre: variacion.nombre,
      activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          variacion.activo = activo;
          this.toast(activo ? 'Variacion activa' : 'Variacion inactiva');
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarVariacion(id: number): void {
    if (!confirm('Eliminar variacion?')) { return; }
    this.v4.eliminarVariacionBase(id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Variacion eliminada');
          this.getVariaciones();
          if (this.variacionConfigurando?.id === id) {
            this.variacionConfigurando = null;
            this.configuraciones = [];
          }
        }
      },
      (error) => console.error(error)
    );
  }

  getConfiguraciones(variacionId: number): void {
    this.v4.getConfiguraciones(variacionId).subscribe(
      (data: any) => {
        if (data.success) {
          this.configuraciones = data.content || [];
        }
      },
      (error) => console.error(error)
    );
  }

  agregarConfiguracion(): void {
    if (!this.variacionConfigurando) { return; }
    if (!this.configForm.configuracion.trim()) {
      this.toast('Configuracion requerida', '#CA0B00');
      return;
    }
    const payload: any = {
      configuracion: this.configForm.configuracion,
      descripcion: this.configForm.descripcion,
      activo: this.configForm.activo,
      variacion: this.variacionConfigurando.id
    };
    if (this.configImagen) {
      payload.imagen = this.configImagen;
    }
    this.v4.crearConfiguracion(payload).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Configuracion creada');
          this.configForm = { configuracion: '', descripcion: '', activo: 1 };
          this.configImagen = null;
          this.getConfiguraciones(this.variacionConfigurando.id);
        }
      },
      (error) => console.error(error)
    );
  }

  toggleConfiguracion(config: any): void {
    const activo = config.activo === 0 ? 1 : 0;
    this.v4.actualizarConfiguracion(config.id, {
      configuracion: config.configuracion,
      descripcion: config.descripcion || '',
      variacion: config.variacion || this.variacionConfigurando?.id,
      activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          config.activo = activo;
          this.toast(activo ? 'Configuracion activa' : 'Configuracion inactiva');
        }
      },
      (error) => console.error(error)
    );
  }

  seleccionarConfiguracion(modal: any, config: any): void {
    this.configEditForm = {
      id: config.id,
      configuracion: config.configuracion || '',
      descripcion: config.descripcion || '',
      activo: config.activo === 0 ? 0 : 1
    };
    this.editConfiguracionModalRef = this.modalService.open(modal, { ariaLabelledBy: 'modal-editar-configuracion' });
  }

  actualizarConfiguracion(): void {
    if (!this.configEditForm.id) { return; }
    if (!this.configEditForm.configuracion.trim()) {
      this.toast('Nombre requerido', '#CA0B00');
      return;
    }
    this.v4.actualizarConfiguracion(this.configEditForm.id, {
      configuracion: this.configEditForm.configuracion,
      descripcion: this.configEditForm.descripcion,
      variacion: this.variacionConfigurando?.id,
      activo: this.configEditForm.activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Item actualizado');
          this.configEditForm = { id: 0, configuracion: '', descripcion: '', activo: 1 };
          this.editConfiguracionModalRef?.close();
          this.editConfiguracionModalRef = null;
          if (this.variacionConfigurando) {
            this.getConfiguraciones(this.variacionConfigurando.id);
          }
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarConfiguracion(id: number): void {
    if (!confirm('Eliminar configuracion?')) { return; }
    this.v4.eliminarConfiguracion(id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Configuracion eliminada');
          if (this.configEditForm.id === id) {
            this.configEditForm = { id: 0, configuracion: '', descripcion: '', activo: 1 };
          }
          if (this.variacionConfigurando) {
            this.getConfiguraciones(this.variacionConfigurando.id);
          }
        }
      },
      (error) => console.error(error)
    );
  }

  onConfigFileChange(event: any): void {
    const file = event.target.files[0];
    this.configImagen = file || null;
  }

  abrirFotosConfiguracion(modal: any, config: any): void {
    this.configuracionFotosTarget = config;
    this.configuracionImagenes = [];
    this.configuracionImagenFiles = [];
    this.configuracionImagenForm = { titulo: '', orden: 0, activo: 1 };
    this.loadConfiguracionImagenes(config.id);
    this.modalService.open(modal, { ariaLabelledBy: 'modal-fotos-configuracion', size: 'lg' });
  }

  loadConfiguracionImagenes(configuracionId: number): void {
    this.loadingConfigImagenes = true;
    this.v4.getConfiguracionImagenes(configuracionId).subscribe(
      (data: any) => {
        this.loadingConfigImagenes = false;
        if (data.success) {
          this.configuracionImagenes = data.content || [];
        }
      },
      (error) => {
        this.loadingConfigImagenes = false;
        console.error(error);
      }
    );
  }

  agregarFotosConfiguracion(): void {
    if (!this.configuracionFotosTarget || !this.configuracionImagenFiles.length) {
      this.toast('Seleccione imagenes', '#CA0B00');
      return;
    }
    let pendientes = this.configuracionImagenFiles.length;
    this.configuracionImagenFiles.forEach((file, index) => {
      this.v4.crearConfiguracionImagen({
        configuracion: this.configuracionFotosTarget.id,
        titulo: this.configuracionImagenForm.titulo,
        orden: Number(this.configuracionImagenForm.orden || 0) + index,
        activo: this.configuracionImagenForm.activo,
        imagen: file
      }).subscribe(
        (data: any) => {
          pendientes -= 1;
          if (!data.success) {
            console.error(data.error);
          }
          if (pendientes === 0) {
            this.toast('Imagenes agregadas');
            this.configuracionImagenFiles = [];
            this.configuracionImagenForm = { titulo: '', orden: 0, activo: 1 };
            this.loadConfiguracionImagenes(this.configuracionFotosTarget.id);
            if (this.variacionConfigurando) {
              this.getConfiguraciones(this.variacionConfigurando.id);
            }
          }
        },
        (error) => {
          pendientes -= 1;
          console.error(error);
          if (pendientes === 0) {
            this.loadConfiguracionImagenes(this.configuracionFotosTarget.id);
          }
        }
      );
    });
  }

  toggleFotoConfiguracion(imagen: any): void {
    const activo = imagen.activo === 0 ? 1 : 0;
    this.v4.actualizarConfiguracionImagen(imagen.id, {
      configuracion: imagen.configuracion || this.configuracionFotosTarget?.id,
      titulo: imagen.titulo || '',
      orden: imagen.orden || 0,
      activo
    }).subscribe(
      (data: any) => {
        if (data.success) {
          imagen.activo = activo;
          this.toast(activo ? 'Imagen activa' : 'Imagen inactiva');
        }
      },
      (error) => console.error(error)
    );
  }

  eliminarFotoConfiguracion(imagen: any): void {
    if (!confirm('Eliminar imagen?')) { return; }
    this.v4.eliminarConfiguracionImagen(imagen.id).subscribe(
      (data: any) => {
        if (data.success) {
          this.toast('Imagen eliminada');
          this.loadConfiguracionImagenes(this.configuracionFotosTarget.id);
          if (this.variacionConfigurando) {
            this.getConfiguraciones(this.variacionConfigurando.id);
          }
        }
      },
      (error) => console.error(error)
    );
  }

  onConfigImagenesChange(event: any): void {
    const files = event.target.files || [];
    this.configuracionImagenFiles = [];
    for (let i = 0; i < files.length; i += 1) {
      this.configuracionImagenFiles.push(files[i]);
    }
  }

  get variacionesFiltradas() {
    const term = this.filtro.toLowerCase();
    const filtroTipo = this.filtroTipo.toLowerCase();
    return this.variaciones.filter((v) => {
      const nombre = (v.nombre || '').toLowerCase();
      const tipo = this.getVariacionTipo(v).toLowerCase();
      const label = this.getVariacionLabel(v).toLowerCase();
      const matchTexto = !term || nombre.includes(term) || tipo.includes(term) || label.includes(term);
      const matchTipo = !filtroTipo || tipo === filtroTipo;
      const matchActivo = this.filtroActivo === '' || String(v.activo === 0 ? 0 : 1) === String(this.filtroActivo);
      return matchTexto && matchTipo && matchActivo;
    });
  }

  get configuracionesFiltradas() {
    const term = this.filtroConfig.toLowerCase();
    return this.configuraciones.filter((config) => {
      const texto = `${config.configuracion || ''} ${config.descripcion || ''}`.toLowerCase();
      return !term || texto.includes(term);
    });
  }

  buildImagePath(imagen?: string): string {
    if (!imagen) {
      return this.defaultImage;
    }
    if (imagen.startsWith('http')) {
      return imagen;
    }
    return `${environment.BASE_URL}${imagen}`;
  }

  private getTiposProductoCatalogo(): void {
    this.v4.getTiposProducto({ activo: 1 }).subscribe(
      (data: any) => {
        if (data.success) {
          this.tiposProductoCatalogo = data.content || [];
          this.ordenarTiposCatalogo();
        }
      },
      (error) => console.error(error)
    );
  }

  private aplicarTipoNuevo(nombre: string): void {
    if (this.tipoDestino === 'editar') {
      this.formVariacionEdit.tipo = nombre;
      return;
    }
    this.formVariacion.tipo = nombre;
  }

  private ordenarTiposCatalogo(): void {
    this.tiposProductoCatalogo = [...this.tiposProductoCatalogo].sort((a, b) =>
      String(a.nombre || '').localeCompare(String(b.nombre || ''))
    );
  }

  private toast(title: string, color: string = '#4CAF50'): void {
    this.iziToast.show({
      title,
      titleColor: '#f8f8ff',
      color,
      position: 'topRight',
      closeOnEscape: true
    });
  }

  private existeVariacion(tipo: string, nombre: string, idIgnorar?: number): boolean {
    const tipoNormalizado = (tipo || '').trim().toLowerCase();
    const nombreNormalizado = (nombre || '').trim().toLowerCase();
    return this.variaciones.some((variacion) => {
      const mismoId = idIgnorar && Number(variacion.id) === Number(idIgnorar);
      return !mismoId
        && this.getVariacionTipo(variacion).trim().toLowerCase() === tipoNormalizado
        && (variacion.nombre || '').trim().toLowerCase() === nombreNormalizado;
    });
  }

  private getApiError(data: any): string {
    if (!data?.error) {
      return '';
    }
    if (typeof data.error === 'string') {
      return data.error;
    }
    const firstKey = Object.keys(data.error)[0];
    const firstValue = firstKey ? data.error[firstKey] : '';
    return Array.isArray(firstValue) ? firstValue[0] : String(firstValue || '');
  }
}
